(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsl-google-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tsl-slider')) {
    customElements.define('tsl-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.dots = this.querySelector('[data-dots]');
        const cards = Array.from(this.track.children);
        const step = () => {
          const c = cards[0];
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return c ? c.getBoundingClientRect().width + gap : this.track.clientWidth;
        };
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
        if (this.dots && cards.length > 1) {
          this.dots.innerHTML = cards.map((_, i) => '<button type="button" aria-label="Go to review ' + (i + 1) + '"></button>').join('');
          Array.from(this.dots.children).forEach((b, i) => b.addEventListener('click', () => {
            const card = cards[i];
            this.track.scrollTo({ left: card.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2, behavior: 'smooth' });
          }));
        }
        this.addEventListener('click', (e) => {
          const more = e.target.closest('[data-more]');
          if (!more) return;
          const card = more.closest('[data-card]');
          const open = card.classList.toggle('is-open');
          more.textContent = open ? more.dataset.openLabel : more.dataset.closedLabel;
        });
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        requestAnimationFrame(() => {
          this.querySelectorAll('[data-text]').forEach((t) => {
            const btn = t.parentElement.querySelector('[data-more]');
            if (btn) btn.hidden = t.scrollHeight <= t.clientHeight + 2;
          });
          this.update();
        });
      }
      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth - 2;
        if (this.prevBtn) this.prevBtn.disabled = t.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = t.scrollLeft >= max;
        if (this.dots) {
          const center = t.scrollLeft + t.clientWidth / 2;
          let best = 0, dist = Infinity;
          Array.from(t.children).forEach((c, i) => {
            const d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center);
            if (d < dist) { dist = d; best = i; }
          });
          Array.from(this.dots.children).forEach((b, i) => b.setAttribute('aria-current', i === best ? 'true' : 'false'));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsl-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tsl-slider')) {
    customElements.define('tsl-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.dots = this.querySelector('[data-dots]');
        const cards = Array.from(this.track.children);
        const step = () => {
          const c = cards[0];
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return c ? c.getBoundingClientRect().width + gap : this.track.clientWidth;
        };
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
        if (this.dots && cards.length > 1) {
          this.dots.innerHTML = cards.map((_, i) => '<button type="button" aria-label="Go to review ' + (i + 1) + '"></button>').join('');
          Array.from(this.dots.children).forEach((b, i) => b.addEventListener('click', () => {
            const card = cards[i];
            this.track.scrollTo({ left: card.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2, behavior: 'smooth' });
          }));
        }
        this.addEventListener('click', (e) => {
          const more = e.target.closest('[data-more]');
          if (!more) return;
          const card = more.closest('[data-card]');
          const open = card.classList.toggle('is-open');
          more.textContent = open ? more.dataset.openLabel : more.dataset.closedLabel;
        });
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        requestAnimationFrame(() => {
          this.querySelectorAll('[data-text]').forEach((t) => {
            const btn = t.parentElement.querySelector('[data-more]');
            if (btn) btn.hidden = t.scrollHeight <= t.clientHeight + 2;
          });
          this.update();
        });
      }
      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth - 2;
        if (this.prevBtn) this.prevBtn.disabled = t.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = t.scrollLeft >= max;
        if (this.dots) {
          const center = t.scrollLeft + t.clientWidth / 2;
          let best = 0, dist = Infinity;
          Array.from(t.children).forEach((c, i) => {
            const d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center);
            if (d < dist) { dist = d; best = i; }
          });
          Array.from(this.dots.children).forEach((b, i) => b.setAttribute('aria-current', i === best ? 'true' : 'false'));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
